import { auth, db } from '../../plugins/firebase'
import { Client } from '../../api'
import moment from 'moment'
import { getSunrise, getSunset } from 'sunrise-sunset-js'

const state = {
    profile: null,
    logged: false,
    collection: null,
    location: '',
    sunrise_suntime_hours: null,
    sunrise_suntime_minutes: null,
    sunset_suntime_hours: null,
    sunset_suntime_minutes: null,
    sky_status: 'Clear',
    sky_temp: 94,
    sky_img: null,
    sky_ofs: null,
    view: 'Circuit',
    key: '94260d97055e949eada6d5d9b569c49a',
    userID: ''
}

const getters = {
    getProfile: state => state.profile
}

const actions = {
    checkLogin({ state, commit, dispatch }){
        return new Promise(async (resolve, reject) => {
            if(auth.currentUser){

                let user = auth.currentUser
                // console.log(user);
                if(!state.collection) commit('UPDATE_COLLECTION', user.uid)
                commit('SET_USER_ID', user.uid)
                let userData = await state.collection.get()
                // console.log(userData.data().level);
                // if (userData.data().level === 'USER') {
                //     console.log(userData.data().account);
                //     commit('UPDATE_COLLECTION', userData.data().account)
                //     commit('SET_USER_ID', userData.data().account)
                //     userData = await state.collection.get()
                //     userData.data().level = 'USER'
                // }
                await dispatch('setUserProfile', { ...userData.data(), email: user.email })
                // console.log(userData.data());
                let location = userData.data().city
                commit('UPDATE_LOGIN', true)
                commit('SET_LOCATION', location)
                await dispatch('setSkyConditions')
                resolve()

            }else{
                await dispatch('setUserProfile', {})
                commit('UPDATE_COLLECTION')
                commit('UPDATE_LOGIN', false)
                resolve()
            }
                
        })
    },
    login({ state, commit }, credentials){
        return new Promise(async (resolve, reject) => {
            if(state.logged) return resolve({ message: 'Ya esta logueado' })
            try {
                let { user } = await auth.signInWithEmailAndPassword(credentials.email, credentials.password)
                return resolve({ message: 'Login exitoso' })
            } catch (error) {
                return reject({ message: 'Revisa los datos' })
            }
        })
    },
    async recoverPassword({ state, commit }, email){
        return new Promise(async (resolve, reject) => {
            try {
                await auth.sendPasswordResetEmail(email)
                return resolve({ message: 'Correo mandado exitosamente' })
            } catch (error) {
                return reject({ message: 'No se pudo procesar la solicitud' })
            }
        })
    },
    async setUserProfile({ commit }, user){
        if(!user) return
        if(user.token) Client.changeToken(user.token)
        commit('SET_PROFILE', user)
    },
    logout({ state, commit }){
        return new Promise(async (resolve, reject) =>{
            if(!state.logged) return resolve({ message: 'No has hecho login' })
            try {
                await auth.signOut()
                return resolve({ message: 'Sesión terminada' })
            } catch (error) {
                return reject({ message: 'Error al cerrar sesión' })
            }
        })
    },
    async setSkyConditions({ state, commit }){
        // console.log(state.location);
        // console.log(state.key);

        const apiData = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${state.location},mx&appid=${state.key}`)
        const apiRes = await apiData.json()
        const lat = apiRes.coord.lat
        const lng = apiRes.coord.lon
        const offset = apiRes.timezone
        const status = apiRes.weather[0].description
        const temp = await Math.round((apiRes.main.temp - 273.15) * 9/5 + 32)
        const sunset = getSunset(lat, lng)
        const sunrise = getSunrise(lat, lng)
        // console.log(sunset);
        // console.log(sunrise);
        // const sunData = await fetch(`https://api.sunrise-sunset.org/json?lat=${lat}&lng=${lng}`)
        // const sunRes = await sunData.json()
        // const sunrise = sunRes.results.sunrise
        // const sunset = sunRes.results.sunset
        // const sr_formatted = moment(sunrise, "h:mm:ss A").add(offset, 'seconds').format('HH:mm')
        // const ss_formatted = moment(sunset, "h:mm:ss A").add(offset, 'seconds').format('HH:mm')
        const sr_formatted = moment(sunrise, "h:mm:ss A").format('HH:mm')
        const ss_formatted = moment(sunset, "h:mm:ss A").format('HH:mm')
        // console.log(sr_formatted);
        // console.log(ss_formatted);
        const sr_hours = ("0" + Number(sr_formatted.substring(0, 2))).slice(-2)
        const ss_hours = ("0" + Number(ss_formatted.substring(0, 2))).slice(-2)
        const sr_minutes = ("0" + Number(sr_formatted.substring(3, 5))).slice(-2)
        const ss_minutes = ("0" + Number(ss_formatted.substring(3, 5))).slice(-2)
        let cond = ''
        let ind = ''
        if (status == 'clear sky') { cond = 'Clear'; ind = '01'}
        else if ( status == 'few clouds' ) { cond = 'Few clouds'; ind = '02' }
        else if ( status == 'scattered clouds' ) { cond = 'Cloudy'; ind = '03' }
        else if ( status == 'broken clouds' ||
                    status == 'overcast clouds') { cond = 'Very cloudy'; ind = '04' }
        else if ( status == 'light rain' ||  
                    status == 'light intensity shower rain' || 
                    status == 'light intensity drizzle' || 
                    status == 'drizzle' ||
                    status == 'light intensity drizzle rain' ||
                    status == 'drizzle rain' ) { cond = 'Light rain'; ind = '10' }
        else if ( status == 'moderate rain' || 
                    status == 'shower rain' || 
                    status == 'ragged shower rain' ||
                    status == 'shower rain and drizzle' ||
                    status == 'shower drizzle' ) { cond = 'Rain'; ind = '09' }
        else if ( status == 'heavy intensity rain' || 
                    status == 'very heavy rain' || 
                    status == 'extreme rain' || 
                    status == 'heavy intensity shower rain' ||
                    status == 'heavy intensity drizzle' ||
                    status == 'heavy intensity drizzle rain' ||
                    status == 'heavy shower rain and drizzle') { cond = 'Heavy rain'; ind = '09' }        
        else if ( status == 'freezing rain' ) { cond = 'Freezing rain'; ind = '13' }        
        else if ( status == 'thunderstorm' || 
                    status == 'thunderstorm with light rain' || 
                    status == 'thunderstorm with rain' ||
                    status == 'thunderstorm with heavy rain' ||
                    status == 'light thunderstorm' ||
                    status == 'heavy thunderstorm' ||
                    status == 'ragged thunderstorm' ||
                    status == 'thunderstorm with light drizzle' ||
                    status == 'thunderstorm with drizzle' ||
                    status == 'thunderstorm with heavy drizzle' ) { cond = 'Thunderstorm'; ind = '11' }
        else if ( status == 'mist' ||
                    status == 'Haze' ||
                    status == 'fog' || status == 'haze' ) { cond = 'Mist'; ind = '50' }
        else if ( status == 'Smoke' ) { cond = 'Smoke'; ind = '50' }
        else if ( status == 'sand/ dust whirls' ||
                    status == 'sand' ||
                    status == 'dust' ||
                    status == 'volcanic ash' ) { cond = 'Dust'; ind = '50' }
        else if ( status == 'squalls' || 
                    status == 'tornado' ) { cond = 'Windy'; ind = '50' }
        else { cond = 'Snow'; ind = '13' }
        const utc = moment.utc()
        const hour = utc.format("LTS")
        const actualHour = moment(hour, "h:mm:ss A").add(offset, 'seconds').format('HH:mm')
        const hh = Number(moment(actualHour, 'HH:mm:ss').format('HH'))
        const hh_sr = Number(sr_hours)
        const hh_ss = Number(ss_hours)
        const dn = (hh >= hh_sr && hh <= hh_ss) ? 'd' : 'n'
        const link = `https://openweathermap.org/img/wn/${ind}${dn}@2x.png`
        const data = {
            HSR: sr_hours,
            MSR: sr_minutes,
            HSS: ss_hours,
            MSS: ss_minutes,
            CND: cond, 
            LNK: link,
            TMP: temp,
            OFS: offset/3600
        }
        localStorage.setItem('offset', JSON.stringify(data.OFS))
        commit('SET_SUN_SCHEDULE', { data })
    },
    async editUser({commit}, data){
        let {u_minutesToDanger, u_state, u_city} = data
        let user = auth.currentUser
        await db.doc(`users/${user.uid}`).update({
            city: u_city,
            state: u_state,
            minutesToDanger: u_minutesToDanger
        })
        commit('SET_LOCATION', u_city)
    },

}

const mutations = {
    UPDATE_LOGIN(state, value){
        state.logged = value
    },
    SET_LOCATION(state, value){
        state.location = value
    },
    SET_PROFILE(state, value){
        state.profile = value
        // console.log(value);
    },
    UPDATE_COLLECTION(state, path){
        path 
            ? state.collection = db.doc(`users/${path}`)
            : state.collection = null
    },
    SET_SUN_SCHEDULE(state, value){
        state.sunrise_suntime_hours = value.data.HSR
        state.sunrise_suntime_minutes = value.data.MSR
        state.sunset_suntime_hours = value.data.HSS
        state.sunset_suntime_minutes = value.data.MSS
        state.sky_status = value.data.CND
        state.sky_temp = value.data.TMP
        state.sky_img = value.data.LNK
        state.sky_ofs = value.data.OFS
    },
    SET_USER_ID(state, value){
        state.userID = value
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
